import { render, staticRenderFns } from "./MarketRuleObj.vue?vue&type=template&id=3f5a1888&scoped=true"
import script from "./MarketRuleObj.vue?vue&type=script&lang=js"
export * from "./MarketRuleObj.vue?vue&type=script&lang=js"
import style0 from "./MarketRuleObj.vue?vue&type=style&index=0&id=3f5a1888&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5a1888",
  null
  
)

export default component.exports